export default __webpack_public_path__ + "static/media/NZBW4947.c054fcea.jpeg";